import React, { lazy, Suspense } from 'react';
import { render } from 'react-dom';
import { parseDatasetToProps } from "../../parseDatasetToProps";

const ProductAppointmentWizard = lazy(() => import(/* webpackChunkName: "ProductAppointmentWizard" */ './components/ProductAppointmentWizard'));

const productAppointmentWizard = document.getElementById('product-appointment-wizard');
if (productAppointmentWizard != null) {
    const props = parseDatasetToProps(productAppointmentWizard.dataset);

    render(
        <Suspense fallback={<></>}>
            <ProductAppointmentWizard
                {...props}
            />
        </Suspense>,
        productAppointmentWizard
    );
}
